// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1hAx5","infoBtn":"quickbooks_infoBtn__2ZGY-","formBox":"quickbooks_formBox__3W_x2","formFooter":"quickbooks_formFooter__174Vb"};